module.exports = __webpack_public_path__ + "img/36600.a8087bda.jpg";